import React from 'react';
import classNames from 'classnames/bind';
import { Text } from '@carnica/ui-kit';
import styles from "./styles.pcss";
var cx = classNames.bind(styles);
export var NavigationItem = function NavigationItem(_ref) {
  var item = _ref.item,
    isActive = _ref.isActive,
    onClick = _ref.onClick,
    onHover = _ref.onHover,
    href = _ref.href;
  return /*#__PURE__*/React.createElement(Text, {
    className: cx('item'),
    color: isActive ? 'primary-invert' : 'secondary',
    href: href,
    onClick: onClick,
    onMouseEnter: onHover,
    size: "s",
    tagName: "a",
    "data-t-id": "NavigationLinks-NavigationItem"
  }, item.title);
};